/* eslint-disable */
import {IS_PROD} from "modules/constants";
import React, {Fragment, useState, PropsWithChildren, useEffect} from "react";
import {JSONTree} from "react-json-tree";

import styled from "@emotion/styled";
import RallySSO from "modules/utils/SSO/rallySSO";
import {Button} from "@mui/material";

const Area = styled.div`
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100px;
	height: 100px;
	z-index: 9999;
	background: transparent;
`;

const Buttons = styled.div`
	padding: 100px;
	display: flex;
	flex-flow: column;
`;

type TCheckSentry = {
	myUndefinedFUnction?: () => void;
};

const checkSentry: TCheckSentry = {};

export const HOCDebugInformation: React.FC<PropsWithChildren> = ({children}) => {
	const [count, setCount] = useState(0);
	const [enableSnapack, setEnableSnapack] = useState(false);
	const [user, setUser] = useState<string>("");

	const showDebugInfo = () => {
		setCount(count + 1);

		if (count > 12) {
			checkSentry.myUndefinedFUnction!();
		}
	};

	function objectOrEmpty<T>(obj: T): T | Record<string, unknown> {
		return obj || {};
	}

	const getUser = async () => {
		try {
			const api = new RallySSO();
			await api.init();
			const user = api.getUser();
			setUser(JSON.stringify(user));
		} catch (e) {
			setUser(JSON.stringify(e));
		}
	};

	const getJsonTreeObject = () => {
		try {
			return {
				isNative: RallySSO.IS_NATIVE,
				location: window.location,
				cookies: document.cookie,
				mlbOkta: window.mlbOkta,
				resource: window.performance.getEntries(),
				mlbNative: objectOrEmpty(window.mlbNative),
				window: Object.keys(window),
				jsBridge: objectOrEmpty(window.jsBridge),
				user: user,
				logger: window.logger,
				rally: {
					inviteToGroup: objectOrEmpty(RallySSO.nativeBridge?.inviteToGroup),
					obj: objectOrEmpty(RallySSO.nativeBridge),
					methods: Object.keys(objectOrEmpty(RallySSO.nativeBridge)!),
					methodsNativeBridge: Object.getOwnPropertyNames(RallySSO.nativeBridge ?? {}),
					methodsMlbNative: Object.getOwnPropertyNames(mlbNative ?? {}),
				},
			};
		} catch (e) {
			return {
				isNative: RallySSO.IS_NATIVE,
				location: window.location,
				cookies: document.cookie,
				mlbOkta: window.mlbOkta,
				logger: window.logger,
				resource: window.performance.getEntries(),
				window: Object.keys(window),
				jsBridge: objectOrEmpty(window.jsBridge),
				user: user,
			};
		}
	};

	const [code, setCode] = useState(`function add(a, b) {\n  return a + b;\n}`);

	const [result, setResult] = useState("");

	useEffect(() => {
		try {
			setResult(JSON.stringify(eval(code)));
		} catch (e) {
			setResult(JSON.stringify(e));
		}
	}, [code]);

	if (IS_PROD) {
		return <Fragment>{children}</Fragment>;
	}

	return (
		<Fragment>
			<Area onClick={showDebugInfo} />

			{count > 10 ? (
				<Fragment>
					{enableSnapack ? (
						<Fragment>
							<textarea onChange={(e) => setCode(e.currentTarget.value)} />
							<span>{result}</span>
							<span id={"log"}> </span>
						</Fragment>
					) : (
						<JSONTree
							 
							data={JSON.parse(JSON.stringify(getJsonTreeObject()))}
						/>
					)}

					<Buttons>
						<Button
							onClick={() => {
								setEnableSnapack(!enableSnapack);
							}}
						>
							enableSnapack
						</Button>
						<Button
							onClick={() => {
								void getUser();
							}}
						>
							get user
						</Button>
					</Buttons>
				</Fragment>
			) : (
				children
			)}
		</Fragment>
	);
};
